var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproachLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 497,
    viewBox: "0 0 265 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M248.379 46.6642L212.923 117.569C171.059 201.239 174.162 307.386 220.539 382.41C242.858 418.467 259.824 445.944 259.824 445.944C276.047 471.937 249.966 509.518 227.57 491.881L29.2594 336.418C11.922 323.383 2.3575 300.542 0.673625 276.442C-1.77188 248.801 6.70028 219.754 25.3547 200.628L213.618 7.22316C234.649 -14.5559 263.054 17.251 248.324 46.5807L248.379 46.6642Z",
    fill: "#E3F2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachLeftArrow);
export default __webpack_public_path__ + "static/media/approach-left-arrow.4d4320fbf102a64dd6265e2b9f2fbae6.svg";
export { ForwardRef as ReactComponent };